let hasTimestamp = window.location.search.indexOf('timestamp') !== -1;

// TODO
//  This method makes a request to the keepAliveController whenever the conditions are met,
//  *in addition to* setting it to do so in 15 minutes. Sebastian thought this went against its purpose
//  and it should be fixed, but wanted to investigate that in a follow-up.
export function keepAliveCart() {
    const miniCartDetailsPromise = window.getMiniCartDetailsFromLocalStorageData();
    miniCartDetailsPromise.then(function (miniCartDetails) {
        if (miniCartDetails.hasItems || window.isSafari() || window.isNonBlankCookie('isLoggedIn') || hasTimestamp) {
            const e = document.createElement('script');
            e.src = secureBaseURL + 'common/keepalive.html';
            e.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(e);
            hasTimestamp = false;
            setTimeout(keepAliveCart, 15 * 60 * 1000);
        }
    });
}
